<template>
  <div class="editeventclass eventdata container-fluid">
    <div class="container-fluid">
      <div class="row" id="">
        <div class="col-md-12">
          <div class="card card-transparent-background mb-0">
            <div class="card-header row pb-0">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-doom-yoga">Edit Event</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <!-- <EventCourseInfo action="update" /> -->
          <EventInfo
                  client_name="DY"
                  field_name="course"
                  event_type="course"
                  action="update"
                  :locations="locations"
                />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EventCourseInfo from "./CourseInfo.vue";
import EventInfo from "@/components/events/EventInfo.vue";

import $, { event } from "jquery";
import axios from "axios";
import moment from "moment";

export default {
  name: "EventCourse",
  components: { EventInfo },
  data() {
    return {
      locations: [
        { text: "ZOOM ONLINE", id: "ZOOM ONLINE" },
        { text: "Kimberley Street, London", id: "Kimberley Street, London" },
        { text: "Dublin, Ireland", id: "Dublin, Ireland" },
        { text: "Studio Doom Yoga, London", id: "Studio Doom Yoga, London" },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style >
.imgFromGroup > div {
  height: calc(100% - 35px);
  max-height: calc(100% - 35px);
}
</style>


// WEBPACK FOOTER //
// src/components/doom_yoga/events/EditEventCourse.vue